import React from "react";

import { IgBorderColors, IgTypography } from "@intelligems/ig-theme";
import { ExperienceListVariationDto } from "@intelligems/ig-types";
import { Grid, ListItemButton, useTheme } from "@mui/material";

interface VariationButtonsProps {
  selectedTestGroup: string | undefined;
  setSelectedTestGroup: (value: string | undefined) => void;
  selectedCard: (id: string) => boolean;
  variations: (Omit<ExperienceListVariationDto, "experienceId"> & {
    experienceId?: string;
  })[];
}

export const VariationButtons = ({
  selectedTestGroup,
  setSelectedTestGroup,
  selectedCard,
  variations,
}: VariationButtonsProps) => {
  const theme = useTheme();
  return (
    <Grid container spacing={2} direction={"row"}>
      {variations.map((variation) => {
        return (
          <Grid item key={variation.id} xs={6}>
            <ListItemButton
              aria-labelledby={variation.name}
              onClick={() => {
                if (selectedTestGroup === variation.id)
                  setSelectedTestGroup(undefined);
                else {
                  setSelectedTestGroup(variation.id);
                }
              }}
              selected={selectedCard(variation.id)}
              sx={{
                transition: "0.2s",
                borderRadius: "4px",
                border: `1px solid ${theme.igBorders.core.default}`,
                "&:hover, &:focus": {
                  border: `1px solid ${IgBorderColors.core.hover}`,
                },
              }}
            >
              <IgTypography variant="body1" sx={{ fontWeight: 600 }}>
                {variation.name}
              </IgTypography>
            </ListItemButton>
          </Grid>
        );
      })}
    </Grid>
  );
};
